module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline"
  }, [(!_vm.courses) ? _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Cargando...\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.courses), function(course) {
    return _c('div', {
      staticClass: "column",
      class: _vm.size
    }, [_c('course-card', {
      attrs: {
        "course": course,
        "teachers": _vm.teachers,
        "price": _vm.price,
        "go": _vm.go,
        "external": _vm.external
      }
    })], 1)
  }), _vm._v(" "), (_vm.courses && _vm.courses.length == 0) ? _c('div', {
    staticClass: "column"
  }, [_vm._m(0)]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "has-text-centered subtitle"
  }, [_vm._v("\n        Aún no tiene ningún curso\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a315f87e","hasScoped":false}!./src/components/grid-courses/template.html
// module id = 422
// module chunks = 1